import React from 'react';
import { Box, Tab, Tabs, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LocationsWidgets } from './LocationsWidgets';

export function MasterDataWidgets() {
  return <LocationsWidgets />;
}

export function MasterDataCardHeader() {
  const { t } = useTranslation();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Typography variant="h6" sx={{ width: '10%' }}>
        {t('dashboard.header.masterData', { defaultValue: 'Master data' })}
      </Typography>
      <Box sx={{ flex: 1 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          TabIndicatorProps={{
            style: {
              backgroundColor: theme.palette.text.secondary,
              height: 2,
            },
          }}
          sx={{ minHeight: '44px', marginBottom: '-8px' }}
        >
          <Tab
            label={
              <Typography variant="label1">
                {t('dashboard.masterDataCardHeader.Locations', {
                  defaultValue: 'Locations',
                })}
              </Typography>
            }
          />
          <Tab
            label={
              <Typography variant="label1">
                {t('dashboard.masterDataCardHeader.transportCompanies', {
                  defaultValue: 'Transport companies',
                })}
              </Typography>
            }
            disabled
          />
          <Tab
            label={
              <Typography variant="label1">
                {t('dashboard.masterDataCardHeader.vehicles', {
                  defaultValue: 'Vehicles',
                })}
              </Typography>
            }
            disabled
          />
        </Tabs>
      </Box>
    </Box>
  );
}
